<template>
  <div
    class="modal fade light"
    id="modalHistory"
    ref="bank"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">ประวัติธุรกรรม</p>
            <button
              aria-label="close"
              data-dismiss="modal"
              class="delete"
            ></button>
          </header>
          <section class="modal-card-body">
            <ul
              id="myTabJust"
              role="tablist"
              class="nav nav-tabs nav-justified md-tabs indigo"
            >
              <li class="nav-item">
                <a
                  id="home-tab-just"
                  data-toggle="tab"
                  href="#deposit-just"
                  role="tab"
                  aria-controls="home-just"
                  aria-selected="true"
                  class="nav-link active"
                  >ฝากเงิน</a
                >
              </li>
              <li class="nav-item">
                <a
                  id="profile-tab-just"
                  data-toggle="tab"
                  href="#withdraw-just"
                  role="tab"
                  aria-controls="profile-just"
                  aria-selected="false"
                  class="nav-link"
                  >ถอนเงิน</a
                >
              </li>
            </ul>

            <div id="myTabContentJust" class="tab-content card pt-5">
              <div
                id="deposit-just"
                style="padding: 10px"
                role="tabpanel"
                aria-labelledby="home-tab-just"
                class="tab-pane fade active show"
              >
                <div class="table-responsive">
                  <div
                    id="history-content-deposit_wrapper"
                    class="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div>
                      <div>
                        <table
                          id="history-content-deposit"
                          class="table dataTable no-footer"
                          width="100%"
                          role="grid"
                          style="width: 100%"
                        >
                          <thead>
                            <tr role="row">
                              <th>รหัสทำรายการ</th>
                              <th>จำนวน</th>
                              <th>เวลา</th>
                              <th>สถานะ</th>
                            </tr>
                          </thead>

                          <tbody v-if="depositList.length > 0">
                            <tr
                              v-for="(data, i) in depositList"
                              v-bind:key="i"
                              role="row"
                            >
                              <td>
                                {{ data.id }}
                              </td>
                              <td>{{ data.Amount | formatNumber }} บาท</td>
                              <td>
                                {{ getDate(data.createdAt) }}
                              </td>
                              <td>
                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 0"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 1"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill .bg-light"
                                  v-if="data.Status == 2"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  รอดำเนินการ
                                </span>

                                <span
                                  class="badge rounded-pill bg-danger"
                                  v-if="data.Status == 3"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  ล้มเหลว
                                </span>
                              </td>
                            </tr>
                          </tbody>

                          <tbody v-if="depositList.length == 0">
                            <tr class="odd">
                              <td
                                valign="top"
                                colspan="4"
                                class="dataTables_empty"
                              >
                                ไม่มีข้อมูล
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="withdraw-just"
                style="padding: 10px"
                role="tabpanel"
                aria-labelledby="profile-tab-just"
                class="tab-pane fade"
              >
                <div class="table-responsive">
                  <div
                    id="history-content-withdraw_wrapper"
                    class="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div>
                      <div>
                        <table
                          id="history-content-withdraw"
                          class="table dataTable no-footer"
                          width="100%"
                          role="grid"
                          style="width: 100%"
                        >
                          <thead>
                            <tr role="row">
                              <th>รหัสทำรายการ</th>
                              <th>จำนวน</th>
                              <th>เวลา</th>
                              <th>สถานะ</th>
                            </tr>
                          </thead>
                          <tbody v-if="withdrawList.length > 0">
                            <tr
                              v-for="(data, i) in withdrawList"
                              v-bind:key="i"
                              role="row"
                            >
                              <td>{{ data.id }}</td>
                              <td>{{ data.Amount | formatNumber }} บาท</td>
                              <td>
                                {{ getDate(data.createdAt) }}
                              </td>
                              <td>
                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 0"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 1"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill .bg-light"
                                  v-if="data.Status == 2"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  รอดำเนินการ
                                </span>

                                <span
                                  class="badge rounded-pill bg-danger"
                                  v-if="data.Status == 3"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  ล้มเหลว
                                </span>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-if="withdrawList.length == 0">
                            <tr class="odd">
                              <td
                                valign="top"
                                colspan="4"
                                class="dataTables_empty"
                              >
                                ไม่มีข้อมูล
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { fetchDeposit } from "@/services/modules/deposit.js";
import { Initialize } from "@/services/modules/withdraw.js";
import { fetchTran } from "@/services/modules/history.js";

import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";

import moment from "moment";
export default {
  name: "HistoryForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],
  data() {
    return { depositList: [], withdrawList: [], Transfer: [], tab: 1 };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function (data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },

    async fetchTransfer() {
      await fetchTran((res) => {
        console.log("fetchTransfer");
        console.log(res.data);

        if (res.status) {
          this.Transfer = res.data;
        } else {
        }
      });
    },

    async fetchDeposit() {
      await fetchDeposit((res) => {
        if (res.status) {
          console.log("fetchDeposit");
          console.log(res);
          this.depositList = res.data;
        } else {
        }
      });
    },
    async fetchWithdraw() {
      await Initialize((res) => {
        console.log("fetchWithdraw");
        console.log(res.data.Transaction);

        if (res.status) {
          this.withdrawList = res.data.Transaction;
        } else {
        }
      });
    },
  },
  async mounted() {
    await this.fetchTransfer();
    await this.fetchDeposit();
    await this.fetchWithdraw();
  },
};
</script>
<style scoped>
.leftdps .nav-link {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/HistoryForm.vue